import styled from 'styled-components';

import VStack from '../VStack';
import ModalWindow from './ModalWindow';
import { useModalState } from './useModalState';
import { ModalConfirm } from './ModalConfirm';
import { ModalInfo } from './ModalInfo';
import { ComponentProps } from 'react';
import React from 'react';
import { ModalMessage } from './ModalMessage';
import { ModalEnlaceExterno } from './ModalEnlacesExternos';

interface ModalSubComponents {
  Window?: any;
}

const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
  e.stopPropagation();
};

const Modal: typeof VStack & ModalSubComponents = styled(VStack).attrs({ className: 'modal-ui' })({});
Modal.Window = ModalWindow;
Modal.defaultProps = {
  position: 'fixed',
  width: '100%',
  height: '100%',
  left: 0,
  right: 0,
  top: 0,
  zIndex: 2000,
  overflow: 'auto',
  bg: 'rgba(0,0,0,0.5)',
  justifyContent: 'center',
  alignItems: 'center',
  onClick: stopPropagation,
};

Modal.displayName = 'Modal';

export default Modal;

export type AutoOpenModalProps = {
  ModalComponent: typeof ModalConfirm | typeof ModalInfo | typeof ModalMessage | typeof ModalEnlaceExterno;
} & Partial<ComponentProps<typeof ModalConfirm>> &
  Partial<ComponentProps<typeof ModalInfo>> &
  Partial<ComponentProps<typeof ModalMessage>> &
  Partial<ComponentProps<typeof ModalEnlaceExterno>>;
export const AutoOpenModal = ({ ModalComponent, ...props }: AutoOpenModalProps) => {
  const [isOpen, , close] = useModalState(true);

  const onCancel = () => {
    props.onCancel && props.onCancel();
    close();
  };

  const onClose = () => {
    props.onClose && props.onClose();
    close();
  };

  const onConfirm = () => {
    props.onConfirm && props.onConfirm();
    close();
  };

  return <ModalComponent {...props} show={isOpen} onConfirm={onConfirm} onCancel={onCancel} onClose={onClose}></ModalComponent>;
};
